<template>
  <div class="purchase-benefit-carousel-component">
    <p class="carousel-name">
      {{ name }}
    </p>
    <div
      class="carousel-slide-content"
    >
      <transition-group
        class="slide"
        :name="transitionName"
        mode="out-in"
      >
        <div
          v-for="(slide, i) in slides"
          v-show="i === activeIndex"
          :key="slide.id"
          class="catalog-slide-container"
        >
          <img
            :src="getSlideImgUrl(slide)"
            alt=""
          />
          <p class="slide-title">
            {{ slide.title }}
          </p>
        </div>
      </transition-group>
    </div>
    <carousel-navigation
      class="purchase-benefit-carousel-navigation"
      :active-index="activeIndex"
      :length="slides.length"
      @navigate="moveToSlide"
    />
  </div>
</template>

<script>
import CarouselNavigation from '@/components/carousels/carousel-navigation';

export default {
  name: 'PurchaseBenefitCarousel',
  components: { CarouselNavigation },
  props: {
    context: {
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
    slides: {
      type: Array,
      default: (() => []),
    },
  },
  data() {
    return {
      activeIndex: 0,
      transitionName: 'slide-right',
    };
  },
  methods: {
    getSlideImgUrl(slide) {
      return this.$store.getters['attachments/get'][slide.imageId]?.url;
    },
    moveToSlide(index) {
      if (index < this.activeIndex) {
        this.transitionName = 'slide-left';
      } else {
        this.transitionName = 'slide-right';
      }
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-benefit-carousel-component {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @include breakpoint(medium) {
    min-height: 45vh;

    .carousel-name {
      font-size: rem-calc(24) !important;
    }

    .carousel-slide-content {
      margin-top: rem-calc(16);
    }
  }

  .carousel-name {
    @include charter-font;
    font-size: rem-calc(32);
    margin: 0 auto;
    text-align: center;
  }

  .carousel-slide-content {
    display: flex;
    flex: 1;
    margin: rem-calc(32) 0 0;
    position: relative;

    .slide,
    .slide-html {
      position: absolute;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
    }

    .slide-right-enter-active,
    .slide-left-enter-active,
    .slide-right-leave-active,
    .slide-left-leave-active {
      transition: all .25s ease-out;
    }

    .slide-left-leave-to,
    .slide-right-enter {
      transform: translateX(70%);
      opacity: 0;
    }

    .slide-left-enter,
    .slide-right-leave-to {
      transform: translateX(-70%);
      opacity: 0;
    }
  }
}
</style>
